import { useId, useState } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { ToggleGroup } from '@ui/kit';
import { CSSRefTransition } from '@utils/react';
import { usePageContext } from '../../../../../context.js';
import { useTaskContext } from '../../../context.js';
import { Canvas } from '../organism.canvas.js';
import { wrapper, toggleGroup, transitionWrapper, crossfadeDurationMs, content } from './container.facit.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FacitContainer(props) {
  const id = useId();
  const pageContext = usePageContext();
  const context = useTaskContext();
  const [tab, setTab] = useState("answer");
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    "data-page-context": pageContext,
    "data-tab": tab,
    children: [context === "facit" && pageContext !== "print" && /*#__PURE__*/jsx("div", {
      className: toggleGroup,
      children: /*#__PURE__*/jsx(ToggleGroup, {
        baseId: id,
        label: "V\xE6lg visningstilstand",
        onTabClick: setTab,
        selectedTabId: tab,
        tabs: [{
          id: "answer",
          title: "Mit svar"
        }, {
          id: "facit",
          title: "Rigtigt svar"
        }]
      })
    }), /*#__PURE__*/jsx(TransitionGroup, {
      component: "div",
      className: transitionWrapper,
      children: /*#__PURE__*/jsx(CSSRefTransition, {
        classNames: content,
        timeout: crossfadeDurationMs
        // As computation of dropzone tile downscaling is quite rough we
        // delay running the animation until the work has had a chance to
        // complete.
        ,
        delayMs: {
          enter: 20,
          exit: 20
        },
        children: ref => /*#__PURE__*/jsx("div", {
          className: content,
          ref: ref,
          children: /*#__PURE__*/jsx(Canvas, {
            ...props,
            facitType: tab === "answer" ? "user-entry" : "should-have"
          })
        })
      }, tab)
    })]
  });
}

export { FacitContainer };
//# sourceMappingURL=container.facit.js.map
